import interpol from './images/interpol.jpg'
import grotta from './images/grotta.jpg'
import bluehouse_image from './images/20180808_164113.jpg'
import Activities from './images/Activities.jpeg'
import Northernlights from './images/NorthernLights.jpg'
import NeighbourHood from '../../images/view-gallery/neighborhood.jpeg';
import greenhouse from './images/1(1).jpg'
import threebedroom from './images/IMG_3846.jpg'
export const Rooms = [{
    "title": "Economy Double Room",
    "From": "from €67 per night",
    image: interpol,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1"
  },
  {
    title: "Double Twin",
    From : "from €99 per night",
    image: "https://bluehouse.is/static/media/dt1.feb270dd.jpg",
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1"
  },
  {
    title: "Triple Room",
    From : "from €125 per night",
    image: "https://bluehouse.is/static/media/t1.7a599542.jpg",
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1"
  },
  {
    title: "Quadruple Room",
    From : "from €67 per night",
    image: grotta,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1"
  }];
  export const Houses = [{
    "title": "Blue house",
    "From": "",
    image: bluehouse_image,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1"
  },
  {
    title: "Green House",
    From : "",
    image: greenhouse,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1"
  },
  {
    title: "3 bedroom apartment",
    From : "",
    image: threebedroom,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1"
  }];

  export const Surroundings = [{
    "title": "Northern Lights",
    From: "",
    image:Northernlights,
    Link: "https://blog.bluehouse.is/"
  },
  {
    title: "Neighbourhood",
    From : "",
    image: NeighbourHood,
    // Link: "bluehouseis.bitbucket.io\src\images\view-gallery\neighborhood.jpeg" 
    Link: "https://blog.bluehouse.is/" 
  },
  {
    title: "Activities",
    From : "",
    image: Activities,
    Link: "https://blog.bluehouse.is/"
  }];